/* Naturally Good Snacks homepage behavior. Runs once even if several sections include it. */
(function () {
  if (window.__ngsHome) return;
  window.__ngsHome = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  var bar = $('[data-ngs-shipbar]');
  var threshold = bar ? parseInt(bar.dataset.threshold, 10) || 5900 : 5900;
  var moneyFormat = (bar && bar.dataset.moneyFormat) || '${{amount}}';
  var cartTotal = bar ? parseInt(bar.dataset.cartTotal, 10) || 0 : 0;

  function money(cents) {
    var fmt = function (n, d, ts, ds) {
      var num = (n / 100).toFixed(d).split('.');
      return num[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts) + (num[1] ? ds + num[1] : '');
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
      return fmt(cents, 2, ',', '.');
    });
  }

  /* ---------- free shipping progress (ribbon + floating pill) ---------- */
  var pill = document.createElement('a');
  pill.className = 'ngs-float';
  pill.href = '#free-shipping';
  pill.innerHTML = '<span class="ring"><b>$' + Math.round(threshold / 100) + '</b></span><span data-ngs-float-msg></span>';
  document.body.appendChild(pill);

  function renderShip() {
    var pct = Math.max(0, Math.min(100, cartTotal / threshold * 100));
    var left = Math.max(0, threshold - cartTotal);
    var msg;
    if (bar) {
      if (cartTotal <= 0) msg = bar.dataset.msgEmpty;
      else if (left > 0) msg = bar.dataset.msgAway.replace('[amount]', money(left));
      else msg = bar.dataset.msgFree;
      var fill = $('[data-ngs-ship-fill]', bar), m = $('[data-ngs-ship-msg]', bar);
      if (fill) fill.style.width = Math.max(cartTotal > 0 ? 4 : 0, pct) + '%';
      if (m) m.textContent = msg;
    }
    pill.querySelector('.ring').style.setProperty('--p', pct.toFixed(1));
    pill.querySelector('[data-ngs-float-msg]').textContent = cartTotal <= 0 ? 'Free shipping at ' + money(threshold) : left > 0 ? money(left) + ' to free shipping' : 'Your order ships free';
  }
  renderShip();
  var hero = $('[data-ngs-hero]');
  function pillVisibility() {
    var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    pill.classList.toggle('is-on', past);
  }
  window.addEventListener('scroll', pillVisibility, { passive: true });
  pillVisibility();

  function refreshCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartTotal = cart.total_price;
        $$('[data-header-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        renderShip();
        return cart;
      });
  }
  var syncTimer;
  function syncSoon() { clearTimeout(syncTimer); syncTimer = setTimeout(function () { refreshCart().catch(function () {}); }, 350); }
  (function hookUpcart(tries) {
    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      try { window.upcartSubscribeCartUpdated(syncSoon); } catch (e) {}
      if (typeof window.upcartSubscribeAddedToCart === 'function') { try { window.upcartSubscribeAddedToCart(syncSoon); } catch (e) {} }
    } else if (tries < 40) { setTimeout(function () { hookUpcart(tries + 1); }, 250); }
  })(0);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) syncSoon(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncSoon(); });

  /* ---------- quick add (UpCart may take over the submit; we stay in sync either way) ---------- */
  function flash(btn) {
    if (!btn) return;
    if (!btn.dataset.label) btn.dataset.label = btn.textContent;
    btn.classList.remove('is-loading'); btn.classList.add('is-added'); btn.textContent = 'Added';
    clearTimeout(btn._t);
    btn._t = setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = btn.dataset.label; btn.disabled = false; }, 1600);
  }
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('.ngs-home [data-ngs-quick]')) {
      var btn = f.querySelector('[type=submit]');
      f._ngsOwn = false;
      setTimeout(function () { syncSoon(); if (!f._ngsOwn) flash(btn); }, 1200);
      setTimeout(syncSoon, 3000);
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('.ngs-home [data-ngs-quick]') || e.defaultPrevented) return;
    e.preventDefault();
    f._ngsOwn = true;
    var btn = f.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var body = new FormData(f);
    if (!body.get('selling_plan')) body.delete('selling_plan');
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        return refreshCart().then(function () {
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (err) {} }
          if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); } catch (err) {} }
          flash(btn);
        });
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        alert((err && (err.description || err.message)) || 'Sorry, that could not be added.');
      });
  });

  /* ---------- craving finder ---------- */
  $$('[data-ngs-cravings]').forEach(function (sec) {
    var grid = $('[data-ngs-grid]', sec);
    var cards = $$('[data-ngs-card]', grid);
    var chips = $$('[data-ngs-chip]', sec);
    var allChip = chips.filter(function (c) { return c.dataset.ngsChip === ''; })[0];
    var sortSel = $('[data-ngs-sort]', sec);
    var more = $('[data-ngs-more]', sec);
    var empty = $('[data-ngs-empty]', sec);
    var countEl = $('[data-ngs-result-count]', sec);
    var perPage = parseInt(sec.dataset.perPage, 10) || 12;
    var countText = sec.dataset.countText || '[count] snacks';
    var shown = perPage;
    var active = [];
    cards.forEach(function (c) { c._tags = (c.dataset.tags || '').split('|').filter(Boolean); });

    function matches(c, list) { return list.every(function (t) { return c._tags.indexOf(t) > -1; }); }

    function readHash() {
      var m = location.hash.match(/craving=([^&]+)/);
      if (!m) return;
      active = decodeURIComponent(m[1]).split(',').filter(function (t) { return chips.some(function (c) { return c.dataset.ngsChip === t; }); });
    }
    function writeHash() {
      var h = active.length ? '#cravings&craving=' + encodeURIComponent(active.join(',')) : '#cravings';
      if (history.replaceState) history.replaceState(null, '', location.pathname + location.search + (location.hash || active.length ? h : ''));
    }

    function render() {
      chips.forEach(function (c) {
        var t = c.dataset.ngsChip;
        c.setAttribute('aria-pressed', t === '' ? String(active.length === 0) : String(active.indexOf(t) > -1));
        var em = $('[data-ngs-chip-count]', c);
        if (em) {
          var next = active.indexOf(t) > -1 ? active : active.concat([t]);
          var n = cards.filter(function (card) { return matches(card, next); }).length;
          em.textContent = n;
          c.classList.toggle('is-zero', n === 0 && active.indexOf(t) === -1);
        }
      });
      var list = cards.filter(function (c) { return matches(c, active); });
      var mode = sortSel ? sortSel.value : 'featured';
      list.sort(function (a, b) {
        if (mode === 'price-asc') return a.dataset.price - b.dataset.price;
        if (mode === 'price-desc') return b.dataset.price - a.dataset.price;
        if (mode === 'title') return a.dataset.title < b.dataset.title ? -1 : 1;
        return a.dataset.order - b.dataset.order;
      });
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= shown; });
      if (more) more.hidden = list.length <= shown;
      if (empty) empty.hidden = list.length > 0;
      if (countEl) countEl.textContent = countText.replace('[count]', list.length);
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var t = c.dataset.ngsChip;
        if (t === '') active = [];
        else if (active.indexOf(t) > -1) active = active.filter(function (x) { return x !== t; });
        else active = active.concat([t]);
        shown = perPage;
        render(); writeHash();
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { render(); });
    if (more) more.addEventListener('click', function () { shown += perPage; render(); });
    readHash();
    render();
    if (allChip && !chips.length) allChip.hidden = true;
  });

  /* ---------- videos: pause toggle, lazy start, reduced motion ---------- */
  var loops = $$('video[data-ngs-loop], [data-ngs-loop] video');
  loops.forEach(function (v) {
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
  });
  var toggle = $('[data-ngs-loop-toggle]');
  if (toggle) {
    var hv = $('[data-ngs-hero] video');
    if (reduce) toggle.setAttribute('aria-pressed', 'true');
    toggle.addEventListener('click', function () {
      if (!hv) return;
      if (hv.paused) { hv.play(); toggle.setAttribute('aria-pressed', 'false'); toggle.setAttribute('aria-label', 'Pause background video'); }
      else { hv.pause(); toggle.setAttribute('aria-pressed', 'true'); toggle.setAttribute('aria-label', 'Play background video'); }
    });
  }
  var lazy = $$('video[data-ngs-lazy]');
  if (lazy.length && 'IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.preload = 'auto'; var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
      });
    }, { rootMargin: '200px' });
    lazy.forEach(function (v) { v.removeAttribute('autoplay'); io.observe(v); });
  }

  /* ---------- story dialog ---------- */
  $$('[data-ngs-story-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      var d = document.getElementById(b.dataset.ngsStoryOpen);
      if (!d) return;
      if (d.showModal) d.showModal(); else d.setAttribute('open', '');
      var v = $('video', d); if (v) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
  $$('.story-dialog').forEach(function (d) {
    var close = function () { var v = $('video', d); if (v) v.pause(); if (d.close) d.close(); else d.removeAttribute('open'); };
    $('[data-ngs-story-close]', d).addEventListener('click', close);
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.addEventListener('close', function () { var v = $('video', d); if (v) v.pause(); });
  });

  /* ---------- keep app widgets out of our quick-add forms ---------- */
  function purge() {
    $$('.ngs-home .sealsubs-target-element, .ngs-home .sealsubs-container').forEach(function (el) { el.remove(); });
    $$('.ngs-home form[data-ngs-quick] input[name="selling_plan"]').forEach(function (el) { el.remove(); });
  }
  purge();
  if ('MutationObserver' in window) {
    var q = false;
    new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; purge(); }); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();
